import React, { useEffect, useState } from "react";
import { FaRegUser } from "react-icons/fa6";
import { FiHash } from "react-icons/fi";
import { IoCallOutline } from "react-icons/io5";
import { GoOrganization } from "react-icons/go";
import { useSelector } from "react-redux";
import {
  FormControl,
  FormControlLabel,
  FormGroup,
  FormHelperText,
  FormLabel,
  Switch,
} from "@mui/material";
import toast from "react-hot-toast";
import apiClient from "../../services/apiClient";

import PageLoader from "../../components/Loading/PageLoader";
import CustomButton from "../../components/Button/CustomButton";

const Settings = () => {
  const [userProfile, setUserProfile] = useState();
  const [loading, setLoading] = useState({
    fetchDetails: false,
    submitProfileDetail: false,
    submitSettingsDetails: false,
  });
  const [profileData, setProfileData] = useState({
    name: "",
    phone_number: "",
    email_id: "",
  });

  const userInfo = useSelector((state) => state?.userInfo?.user);

  const [otherSettings, setOtherSettings] = useState(userInfo?.settings);

  useEffect(() => {
    fetchDetails();
  }, []);

  const fetchDetails = async () => {
    setLoading({ ...loading, fetchDetails: true });

    try {
      const response = await apiClient.get(`/user/${userInfo?.id}`);

      setUserProfile(response?.data);
      setProfileData({
        name: response?.data?.user?.name,
        phone_number: response?.data?.user?.phone_number,
        email_id: response?.data?.user?.email_id,
      });
      setOtherSettings(response?.data?.user?.settings);
    } catch (err) {
      console.log(err);
    } finally {
      setLoading({ ...loading, fetchDetails: false });
    }
  };

  const handleProfileChange = (e) => {
    const { name, value } = e.target;
    setProfileData((prevData) => ({ ...prevData, [name]: value }));
  };

  const handleOtherSettingsChange = (e) => {
    const { name, value } = e.target;
    setOtherSettings((prevData) => ({ ...prevData, [name]: value }));
  };

  const handleProfileSubmit = async (e) => {
    e.preventDefault();
    setLoading({ ...loading, submitProfileDetail: true });

    try {
      const payload = new FormData();
      payload.append("name", profileData?.name);
      payload.append("phone_number", profileData?.phone_number);
      payload.append("email_id", profileData?.email_id);
      payload.append("user_id", userInfo?.id);

      await apiClient.put("/user/update", payload);

      fetchDetails();
      toast.success("Updated !");
    } catch (err) {
      console.log(err);
    } finally {
      setLoading({ ...loading, submitProfileDetail: false });
    }
  };

  const handleSettingsSubmit = async (e) => {
    e.preventDefault();
    setLoading({ ...loading, submitSettingsDetails: true });

    try {
      const payload = new FormData();
      payload.append("user_id", userInfo?.id);
      payload.append("settings", JSON.stringify(otherSettings));

      await apiClient.put("/user/update", payload);

      fetchDetails();
      toast.success("Setting Changed !");
    } catch (err) {
      console.log(err);
    } finally {
      setLoading({ ...loading, submitSettingsDetails: false });
    }
  };

  return (
    <>
      {loading?.fetchDetails && <PageLoader text="loading profile" />}

      <div className="pageTitle1 py-4 px-5">
        <h3 className="mb-2">Settings</h3>
        <p className="m-0">Manage you general information</p>
      </div>

      <div className="p-4">
        <div className="profilePage">
          <form className="row" onSubmit={handleProfileSubmit}>
            <div className="col-xl-12">
              <div className="pickName">
                <figure className="mb-0 me-4">
                  <img src="../Images/profile-icon.png" />
                </figure>

                <div className="nameDtl">
                  <h3 className="m-0">{userProfile?.user?.name || "Unknown"} </h3>
                  <p className="m-0">{userProfile?.user?.email_id || "@.com"}</p>
                </div>
              </div>
            </div>

            <div className="col-12">
              <h3 className="subTitle mb-3">Profile</h3>
            </div>

            <div className="col-xl-5">
              <div className="inputData withIcon my-3">
                <span className="icon">
                  <FaRegUser />
                </span>

                <input
                  type="text"
                  name="name"
                  className="form-control my-2"
                  onChange={handleProfileChange}
                  value={profileData?.name}
                  required
                />
                <label htmlFor="name">Name</label>
              </div>
            </div>

            <div className="col-xl-5">
              <div className="inputData withIcon my-3">
                <span className="icon">
                  <IoCallOutline />
                </span>

                <input
                  type="text"
                  name="phone_number"
                  className="form-control my-2"
                  onChange={handleProfileChange}
                  value={profileData?.phone_number}
                  required
                />
                <label htmlFor="phone_number">Personal Phone Number</label>
              </div>
            </div>

            <div className="col-xl-5">
              <div className="inputData withIcon my-3">
                <span className="icon">
                  <FiHash />
                </span>

                <input
                  type="email"
                  name="email_id"
                  className="form-control my-2"
                  onChange={handleProfileChange}
                  value={profileData?.email_id}
                />
                <label htmlFor="number">Email</label>
              </div>
            </div>

            <div className="col-12 mt-4">
              <h3 className="subTitle mb-3">Company Details</h3>
            </div>

            <div className="col-xl-5">
              <div className="inputData withIcon my-3">
                <span className="icon">
                  <GoOrganization />
                </span>

                <input
                  type="text"
                  name="company_name"
                  className="form-control my-2"
                  onChange={handleProfileChange}
                  value={userProfile?.company?.company_name}
                  required
                />
                <label htmlFor="company_name">Company Name</label>
              </div>
            </div>

            <div className="col-xl-5">
              <div className="inputData withIcon my-3">
                <span className="icon">
                  <GoOrganization />
                </span>

                <input
                  type="text"
                  name="domain"
                  className="form-control my-2"
                  onChange={handleProfileChange}
                  value={userProfile?.company?.domain}
                  required
                />
                <label htmlFor="domain">Company Domain</label>
              </div>
            </div>

            <div className="col-xl-5">
              <div className="inputData withIcon my-3">
                <span className="icon">
                  <GoOrganization />
                </span>

                <input
                  type="text"
                  name="company_owner_name"
                  className="form-control my-2"
                  onChange={handleProfileChange}
                  value={userProfile?.company?.company_owner_name}
                  required
                />
                <label htmlFor="company_owner_name">Company Admin</label>
              </div>
            </div>

            <div className="col-12">
              <div className="d-flex justify-content-end gap-3 mb-4">
                <CustomButton
                  type="button"
                  variant="contained"
                  color="secondary"
                  size="large"
                  width="20%"
                >
                  Cancel
                </CustomButton>

                <CustomButton
                  type="submit"
                  variant="contained"
                  color="primary"
                  loading={loading?.submitProfileDetail}
                  size="large"
                  width="20%"
                >
                  Save
                </CustomButton>
              </div>
            </div>
          </form>
        </div>
      </div>

      {userInfo?.role === "3" && (
        <div className="p-4">
          <div className="profilePage">
            <form className="row" onSubmit={handleSettingsSubmit}>
              <div className="col-xl-12">
                <div className="pickName">
                  <div className="nameDtl">
                    <h3 className="m-0">Extension Setting </h3>
                  </div>
                </div>
              </div>

              <div className="col-12">
                <h3 className="subTitle mb-3">Default</h3>
              </div>

              <div className="col-xl-5">
                <div className="inputData withIcon my-3">
                  <span className="icon">
                    <FiHash />
                  </span>

                  <input
                    type="text"
                    name="caller_id"
                    className="form-control my-2"
                    onChange={handleOtherSettingsChange}
                    value={otherSettings?.default_extension?.caller_id}
                    required
                  />
                  <label htmlFor="caller_id">Allocate Number</label>
                </div>
              </div>

              <div className="col-xl-5">
                <div className="inputData withIcon my-3">
                  <span className="icon">
                    <FiHash />
                  </span>

                  <input
                    type="text"
                    name="extension"
                    className="form-control my-2"
                    onChange={handleOtherSettingsChange}
                    value={otherSettings?.default_extension?.extension}
                    required
                  />
                  <label htmlFor="extension">Extensions</label>
                </div>
              </div>

              <div className="col-xl-5 my-2">
                <FormControl component="fieldset" variant="standard">
                  <FormLabel component="legend">Auto Connections</FormLabel>

                  <FormGroup>
                    <FormControlLabel
                      control={
                        <Switch
                          checked={otherSettings?.auto_connect}
                          onChange={(e) =>
                            setOtherSettings({
                              ...otherSettings,
                              auto_connect: !otherSettings?.auto_connect,
                            })
                          }
                          name="auto_connect"
                        />
                      }
                      label={otherSettings?.auto_connect ? "Auto" : "Manual"}
                    />
                  </FormGroup>

                  <FormHelperText>Connects the extension automatically</FormHelperText>
                </FormControl>
              </div>

              <div className="col-12 my-4">
                <hr />
              </div>

              <div className="col-12">
                <h3 className="subTitle mb-4">Choose Default AI Agent</h3>
              </div>

              <div className="col-xl-5">
                <div className="inputData selectForm my-3">
                  <label>Model</label>

                  <span className="icon">
                    <FiHash />
                  </span>

                  <select className="form-select">
                    <option>Lead Horizon</option>
                    <option value="1">One</option>
                    <option value="2">Two</option>
                    <option value="3">Three</option>
                  </select>
                </div>
              </div>

              <div className="col-12">
                <div className="d-flex justify-content-end gap-3 mb-4">
                  <CustomButton
                    type="button"
                    variant="contained"
                    color="secondary"
                    // onClick={handleClosePopup}
                    size="large"
                    width="20%"
                  >
                    Cancel
                  </CustomButton>

                  <CustomButton
                    type="submit"
                    variant="contained"
                    color="primary"
                    loading={loading?.submitSettingsDetails}
                    size="large"
                    width="20%"
                  >
                    Save Changes
                  </CustomButton>
                </div>
              </div>
            </form>
          </div>
        </div>
      )}
    </>
  );
};

export default Settings;
